import { documentObject, getButton, stopEvent } from '@fold-dev/core'
import { useEffect } from 'react'
import React, { forwardRef, useMemo, useRef } from 'react'

export const FOLD_TODO_DRAG_TASK_CACHE = 'FOLD_TODO_DRAG_TASK_CACHE'

export type TodoEventName = 'edit-task' | 'add-task-below' | 'add-task-above' | 'select'

export const dispatchTodoEvent = (eventName: TodoEventName, data: any = {}) =>
    documentObject.dispatchEvent(new CustomEvent('todo-' + eventName, { detail: data }))

export const useTodoEvent = (event: TodoEventName, handler, passive = false) => {
    useEffect(() => {
        documentObject.addEventListener('todo-' + event, handler, passive)
        return () => documentObject.removeEventListener('todo-' + event, handler)
    })
}

export const getCollapsedStateFromLocalStorage = (key, id) => {
    const cache = localStorage.getItem(key)
    return cache ? !!JSON.parse(cache)[id] : false
}

export const cancelSyntheticClickEvent = () => null
